"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutPreview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="py-24 px-6 bg-background">
      <div className={`max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="relative overflow-hidden rounded-lg shadow-soft">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/freedom_productions_team_portrait.png" alt="Freedom Productions Team" className="w-full h-auto object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-out-back)] hover:scale-[1.02]" />
        </div>

        {}
        <div className="flex flex-col gap-6">
          <div className="space-y-4">
            <h2 className="text-4xl lg:text-5xl font-display font-bold text-foreground leading-tight">
              Who We Are
            </h2>
            <p className="text-lg text-foreground/80 leading-relaxed">
              Freedom Productions, LLC is a management and professional support firm dedicated to helping individuals, small businesses, and creative ventures operate efficiently and achieve measurable growth. We bring structure, clarity, and forward momentum to both business operations and film projects.
            </p>
            <p className="text-lg text-foreground/80 leading-relaxed">
              Our systematic approach removes the stress of day-to-day operations, allowing you to focus on execution and results. Whether it's hands-on project management, strategic guidance, or film development and packaging, we provide the infrastructure and relationships needed at every stage.
            </p>
          </div>

          <div>
            <Link to="/AboutPage">
              <Button variant="default" size="lg" className="group transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] hover:shadow-medium">
                Learn More About Us
                <ArrowRight className="transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:translate-x-1" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}